export const colors = [
  "#ff2825",
  "#fd0061",
  "#a905b6",
  "#6f32be",
  "#00abfb",
  "#00bfd8",
  "#009988",
  "#00b341",
  "#7bc62d",
  "#c9de00",
  "#ffec00",
  "#ffbf00",
  "#ff9300",
  "#ff4500",
  "#7f5345",
  "#9e9e9e",
  "#6f80be",
  "#597e8d",
  "#000000",
  "#ffffff",
];
